import { GENERAL_DISEASE, GENERAL_DISEASE_SUB_TYPE } from 'utils/constants/disease';
import { DISEASE_SUB_TYPE_QUESTION_ID_BY_DISEASE } from 'modules/questionnaire/constants';

const { [GENERAL_DISEASE]: GENERAL_DISEASE_SUB_TYPE_QUESTION_ID } = DISEASE_SUB_TYPE_QUESTION_ID_BY_DISEASE;

export const getGeneralDiseaseSubType = (conditionProfile) => {
  let subTypeQuestionValue = conditionProfile[GENERAL_DISEASE_SUB_TYPE_QUESTION_ID];

  if (!subTypeQuestionValue || (Array.isArray(subTypeQuestionValue) && !subTypeQuestionValue.length)) {
    return null;
  }

  if (Array.isArray(subTypeQuestionValue)) {
    [subTypeQuestionValue] = subTypeQuestionValue;
  }

  return Object.values(GENERAL_DISEASE_SUB_TYPE).includes(subTypeQuestionValue)
    ? subTypeQuestionValue
    : null;
};
